import { render, staticRenderFns } from "./RightLowerBarEditPhotoConfirmation.vue?vue&type=template&id=87939610&scoped=true&"
import script from "./RightLowerBarEditPhotoConfirmation.vue?vue&type=script&lang=js&"
export * from "./RightLowerBarEditPhotoConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87939610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87939610')) {
      api.createRecord('87939610', component.options)
    } else {
      api.reload('87939610', component.options)
    }
    module.hot.accept("./RightLowerBarEditPhotoConfirmation.vue?vue&type=template&id=87939610&scoped=true&", function () {
      api.rerender('87939610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarRightSide/RightLowerBarEditPhotoConfirmation.vue"
export default component.exports